export const TileImage = new Image();
TileImage.src = "/img/tileset.png";

export const EntityImage = new Image();
EntityImage.src = "/img/entity-set.png";

export const DecorationImage = new Image();
DecorationImage.src = "/img/decoration.png";
